export default __webpack_public_path__ + "static/project1-acd8968efc9b228372eb1367fa91c1f6.jpg";